export default __webpack_public_path__ + "static/media/disabled.f6ba2ce5.svg";